import { render, staticRenderFns } from "./PaymentProofFormat.vue?vue&type=template&id=1a93c756&scoped=true"
import script from "./PaymentProofFormat.vue?vue&type=script&lang=js"
export * from "./PaymentProofFormat.vue?vue&type=script&lang=js"
import style0 from "./PaymentProofFormat.vue?vue&type=style&index=0&id=1a93c756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a93c756",
  null
  
)

export default component.exports